// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"c4becd4d","453":"437bcd92","516":"6e9c87fe","799":"149d01ee"}[chunkId] + ".chunk.js";
};